import { Alert, Dialog, DialogActions, DialogContent } from '@mui/material';
import { CustomDialogTitle } from '../../../Modules/Common/Custom/CustomDialogTitle';
import { MDBox } from "./MDBox";
import { MDButton } from './MDButton';
import { MDTypography } from './MDTypography';

interface IProps {
    showDialog: boolean;
    heading: string;
    message: string;
    handleAccept: () => void;
    handleCancel?: () => void;
}

export const WarningDialog = (props: IProps) => {

    return (
        <Dialog open={props.showDialog} onClose={props.handleAccept} aria-labelledby="form-dialog-title" maxWidth='md'>
            <CustomDialogTitle id="customized-dialog-title" onClose={props.handleAccept}>
                {props.heading}
            </CustomDialogTitle>
            <DialogContent>
                <MDBox>
                    <MDTypography variant="button" fontWeight='regular' fontSize="0.9em">
                        <Alert severity='warning'>{props.message}</Alert>
                    </MDTypography>
                </MDBox>
            </DialogContent>
            <DialogActions>
                {props.handleCancel &&
                <MDBox>
                    <MDButton color="primary" variant="outlined" onClick={props.handleCancel}>
                        Cancel
                    </MDButton>
                </MDBox>
                }
                <MDBox display="flex" justifyContent="space-between">
                    <MDButton color="primary" variant="contained" onClick={props.handleAccept}>
                        Ok
                    </MDButton>
                </MDBox>
            </DialogActions>
        </Dialog>
    )
}